<mat-form-field appearance="outline" class="score-select-field" [hideRequiredMarker]="true" [class.has-error]="hasError">
  @if (label) {
    <mat-label>{{ label }}@if (required) {<span class="required-marker">*</span>}</mat-label>
  }
  <mat-select [required]="required" [class.ng-invalid]="hasError" [value]="value" (selectionChange)="onSelectionChange($event.value)" (openedChange)="onPanelOpened($event)" [disabled]="disabled || loading">
    <mat-select-trigger>
      @if (selectedOption) {
        <span class="trigger-content">
          <span class="trigger-label-group">
            <span class="trigger-label">{{ selectedOption.label }}</span>
            @if (selectedOption.subtitle) {
              <span class="trigger-subtitle">{{ selectedOption.subtitle }}</span>
            }
          </span>
          @if (selectedOption.badge) {
            <span class="option-badge">{{ selectedOption.badge }}</span>
          }
          @if (selectedOption.score != null) {
            <span class="score-chip" [ngClass]="selectedOption.scoreClass">{{ selectedOption.score > 100 ? 100 : selectedOption.score }}%</span>
          }
        </span>
      }
    </mat-select-trigger>
    @if (searchable) {
      <div class="option-search" (click)="$event.stopPropagation()">
        <i class="material-symbols-rounded option-search-icon">search</i>
        <input #searchInput type="text" placeholder="Search..."
               [value]="searchText"
               (input)="onSearchChange(searchInput.value)"
               (keydown)="onSearchKeydown($event)" />
      </div>
    }
    @for (opt of filteredOptions; track opt.value) {
      <mat-option [value]="opt.value" [class.has-divider-after]="opt.dividerAfter">
        <span class="option-row">
          <span class="option-label-group">
            <span>{{ opt.label }}</span>
            @if (opt.subtitle) {
              <span class="option-subtitle">{{ opt.subtitle }}</span>
            }
          </span>
          @if (opt.badge) {
            <span class="option-badge">{{ opt.badge }}</span>
          }
          @if (opt.score != null) {
            <span class="score-chip" [ngClass]="opt.scoreClass">{{ opt.score > 100 ? 100 : opt.score }}%</span>
          }
        </span>
      </mat-option>
    }
    @if (searchable && searchText && filteredOptions.length === 0) {
      <div class="option-search-empty">No matches</div>
    }
  </mat-select>
  <i class="material-symbols-rounded" matSuffix>expand_more</i>
  @if (loading) {
    <mat-hint>Loading...</mat-hint>
  }
</mat-form-field>
